/* GIF-style product videos, rendered by snippets/pdp-video.liquid.

   Each video plays only while it is on screen and pauses when scrolled away,
   so an offscreen gallery slide stops using battery. A video lower down the
   page also holds its poster back until it is within 400px, so it costs
   nothing until the visitor gets near it.

   Dawn's pauseAllMedia() pauses every <video> on the page whenever a gallery
   thumbnail is tapped. A muted loop has no reason to stop, so one that gets
   paused while it is still on screen restarts itself.

   Loaded once per section that uses a video; the second load just rescans. */
(function () {
  if (window.pdpVideo) {
    window.pdpVideo.scan();
    return;
  }

  var hasIO = 'IntersectionObserver' in window;

  function play(video) {
    video.muted = true;
    var attempt = video.play();
    if (attempt && attempt.catch) attempt.catch(function () {});
  }

  function showPoster(video) {
    if (!video.dataset.poster) return;
    video.poster = video.dataset.poster;
    video.removeAttribute('data-poster');
  }

  var onScreen = hasIO
    ? new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            video._pdpOn = entry.isIntersecting;
            if (entry.isIntersecting) {
              showPoster(video);
              play(video);
            } else if (!video.paused) {
              video.pause();
            }
          });
        },
        { threshold: 0.25 }
      )
    : null;

  var nearScreen = hasIO
    ? new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            showPoster(entry.target);
            nearScreen.unobserve(entry.target);
          });
        },
        { rootMargin: '400px 0px' }
      )
    : null;

  function scan() {
    document.querySelectorAll('video.pdp-video:not([data-pdp-ready])').forEach(function (video) {
      video.setAttribute('data-pdp-ready', '');

      video.addEventListener('pause', function () {
        if (!video._pdpOn) return;
        setTimeout(function () {
          if (video._pdpOn && video.paused) play(video);
        }, 80);
      });

      if (hasIO) {
        if (video.dataset.poster) nearScreen.observe(video);
        onScreen.observe(video);
      } else {
        showPoster(video);
        video._pdpOn = true;
        play(video);
      }
    });
  }

  window.pdpVideo = { scan: scan };
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
